import { createContext } from 'react';
import { defaultRemoteControlState, ModifiedProcess, RemoteControlState } from '../../contexts/RemoteControlState';
import { Patient, PatientSettingsData } from '../../data/Patient';
import { RemoteClient } from "../../data/RemoteClient";
import { TrainingData } from './TrainingData';

interface RemoteControlContextType {
	userID: string | null;
	state: RemoteControlState;
	currentTraining: TrainingData | null;
	eventTarget: EventTarget;

	setPatientSettings: (settings: PatientSettingsData) => void;
	commitPatientSettings: () => void;
	setProcesses: (processes: ModifiedProcess[]) => void;

	clients: RemoteClient[];
	videoStream: MediaStream | undefined;
	audioStream: MediaStream | undefined;
	speakerOn: boolean;
	setSpeakerOn: (on: boolean) => void;
	microphoneMuted: boolean;
	muteMicrophone: (mute: boolean) => void;
	connectToClient: (client: RemoteClient) => Promise<void>;
	sendMessage: (message: any) => void;
	setRemoteUser: (remoteUserID: string | null, patient: Patient | null) => void;
	refresh: () => void;
	disconnect: () => void;
}

export const RemoteControlContext = createContext<RemoteControlContextType>({
	userID: null,
	state: defaultRemoteControlState,
	currentTraining: null,

	eventTarget: new EventTarget(),

	setPatientSettings: (settings: PatientSettingsData) => { },
	commitPatientSettings: () => { },
	setProcesses: (processes: ModifiedProcess[]) => { },

	clients: [],
	videoStream: undefined,
	audioStream: undefined,
	speakerOn: false,
	setSpeakerOn: (on: boolean) => { },
	microphoneMuted: true,
	muteMicrophone: (mute: boolean) => { },
	connectToClient: (client: RemoteClient) => Promise.resolve(),
	sendMessage: (message: any) => { },
	setRemoteUser: (remoteUserID: string | null, patient: Patient | null) => { },
	refresh: () => { },
	disconnect: () => { }
});
